import { render } from "./Settings.pug?vue&type=template&id=53cc84dd&ts=true&lang=pug&external"
import script from "./Settings.ts?vue&type=script&lang=ts&external"
export * from "./Settings.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53cc84dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53cc84dd', __exports__)) {
    api.reload('53cc84dd', __exports__)
  }
  
  module.hot.accept("./Settings.pug?vue&type=template&id=53cc84dd&ts=true&lang=pug&external", () => {
    api.rerender('53cc84dd', render)
  })

}


export default __exports__